import { observable, action, computed } from 'mobx';
import { api } from '../../../services';
import { usersStore, vehicleInformationStore, registrationStore, installerProvidersStore } from '../../index';
import * as R from 'ramda';

class Step_0 {
  @observable
  formValues = {
    installerProvider: undefined,
    vehicleType: undefined,
    imei: undefined,
    plate: undefined
  };
  @observable inProgress = false;

  constructor(usersStore, registrationStore, vehicleInformationStore, installerProvidersStore) {
    this.usersStore = usersStore;
    this.registrationStore = registrationStore;
    this.vehicleInformationStore = vehicleInformationStore;
    this.installerProvidersStore = installerProvidersStore;
  }

  @action
  setInProgress(inProgress) {
    this.inProgress = inProgress;
  }

  @action
  setInstallerProvider(installerProvider) {
    this.setFormField('installerProvider', installerProvider === undefined ? 'default' : installerProvider);
  }

  @action
  setImei(imei) {
    this.setFormField('imei', imei);
  }

  @action
  setPlate(plate) {
    this.setFormField('plate', plate);
  }

  @action
  setVehicleType(vehicleType) {
    this.setFormField('vehicleType', vehicleType === 'motorbike' ? vehicleType : 'car');
  }

  @computed
  get isValid() {
    return this.imei && this.plate && this.imei.length > 10 && this.plate.length > 2 && !!this.vehicleType;
  }

  @computed
  get installerProvider() {
    return this.formValues.installerProvider;
  }

  @computed
  get imei() {
    return this.formValues.imei;
  }

  @computed
  get plate() {
    return this.formValues.plate;
  }

  @computed
  get vehicleType() {
    return this.formValues.vehicleType;
  }

  getFit2YouPolicy() {
    this.setInProgress(true);

    return api({ action: 'get active insurance policy' }, this.plate)
      .catch(error => {
        return null;
      })
      .finally(() => {
        this.setInProgress(false);
      })
  }


  submit() {
    this.setInProgress(true);

    if (this.imei && this.plate && this.vehicleType) {
      let car = {};
      const installerId = this.installerProvider === 'default' ? undefined : this.installerProvider;
      return api({ action: 'new registration' }, { installerId: installerId, imei: this.imei, plate: this.plate, vehicleType: this.vehicleType })
        .then(registration => {
          const asset = registration.assets[0];
          car = Object.assign({}, asset.car, {
            alimentation: this.vehicleInformationStore.getFuelTypeByAlias(asset.car.alimentation),
            displacement: this.vehicleInformationStore.getEngineTypeBySize(asset.car.displacement)
          });
          if (asset.car.alimentation && asset.car.displacement) {
            return api({ action: 'update asset' }, registration._id, asset._id, Object.assign({}, asset, { car })).then(() => registration._id);
          }
          return registration._id;
        })
        .then(registration_id => api({ action: 'get user' }, registration_id))
        .then(user => {
          this.usersStore.addOrModify({ ...user, ...car });
          this.registrationStore.setSession(user._id);
          return {};
        })
        .catch(error => {
          console.error(error);
          return { error };
        })
        .then(({ error }) => {
          this.setInProgress(false);
          if (error) {
            throw error;
          }
        });
    } else {
      throw new Error('parameter are not valid');
    }
  }

  @action
  setFormField(field, value) {
    if (field && field.split('.').length > 1) {
      this.formValues = R.assocPath([...field.split('.')], value, this.formValues);
    } else {
      this.formValues = R.assocPath([field], value, this.formValues);
    }
  }
}

export default new Step_0(usersStore, registrationStore, vehicleInformationStore);



// WEBPACK FOOTER //
// ./src/stores/registrationStore/steps/step_0.js